if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.addToCartText = this.submitButton.querySelector('span.text-add-to-cart');
        this.iconAddedToCart = this.submitButton.querySelector('.icon-added-to-cart');
        this.iconPlusAddToCart = this.submitButton.querySelector('.icon-plus-add-to-cart');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.template = this.dataset.template;
        this.freeGiftFirstAvailableVariant = this.dataset.freeGiftFirstAvailableVariant;
        this.productId = this.dataset.productId;

        this.stickyAddCartBtn = document.querySelector('.product__sticky-bar .button__wrapper');
        if (this.stickyAddCartBtn) {
          this.stickyAddCartBtn.addEventListener('click', () => {
            this.querySelector('[id^="ProductSubmitButton-"]')?.click();
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            try {              
              if (window.themeSettings.is_buy_x_get_y_auto_add && this.freeGiftFirstAvailableVariant && this.template === 'product') {
                const addBody = JSON.stringify({
                  id: this.freeGiftFirstAvailableVariant,
                  quantity: 1
                });

                try {
                  const addResponse = await fetch(`${routes.cart_add_url}`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: addBody
                  });
                  
                  const addResult = await addResponse.json();
                  console.log('response', addResult);
                } catch (error) {
                  console.error('Error adding free gift to cart:', error);
                }
              }
            } catch (error) {
              console.error('Error fetching cart:', error);
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
              
              // Check if product has complete your ride modal and show it
              if (this.productId) {
                console.log('this.productId', this.productId, 'modal', document.getElementById(`CompleteYourRideModal-${this.productId}`));
                const modal = document.getElementById(`CompleteYourRideModal-${this.productId}`);
                if (modal) {
                  // Delay to allow cart notification to show first
                  setTimeout(() => {
                    document.getElementById(`CompleteYourRideModal-${this.productId}`).show();
                  }, 300);
                }
              }

              if(this.addToCartText) {
                this.addToCartText.innerHTML = 'ADDED';
                this.submitButton.classList.add('added');
              };
              if(this.iconAddedToCart) this.iconAddedToCart.classList.remove('hidden');
              if(this.iconPlusAddToCart) this.iconPlusAddToCart.classList.add('hidden');  
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.submitButton.classList.remove('added');
        this.iconAddedToCart.classList.add('hidden');
        this.iconPlusAddToCart.classList.remove('hidden');
        
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (text) {
            this.submitButtonText.textContent = text;
          } else {
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
